// import React, { useState, useEffect } from 'react';


// const Fireadvisory = () => {
//   const [advisories, setAdvisories] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;

//   // Function to fetch advisories - reusable
//   const fetchAdvisories = async () => {
//     setIsLoading(true);
//     setError(null);
//     try {
//       // Ensure the backendUrl is correctly defined in your environment or replace it if needed
//       const response = await fetch(`${backendUrl}/firerisk/firerisk-advisories/`);

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`HTTP error! status: ${response.status}. Response: ${errorText.substring(0, 200)}`);
//       }
//       const data = await response.json();
//       setAdvisories(Array.isArray(data) ? data : []);
//     } catch (e) {
//       console.error("Failed to fetch advisories:", e);
//       setError("Failed to load advisories. Please try again later.");
//       setAdvisories([]); // Clear advisories on error
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAdvisories();
//   }, []); // Initial fetch on component mount

//   // Initial loading state before any advisories are fetched
//   if (isLoading && advisories.length === 0 && !error) {
//     return <div style={{ padding: "20px", textAlign: "center" }}>Loading advisories...</div>;
//   }

//   // Display error message if any and no data is available
//   if (error && advisories.length === 0) {
//     return <div style={{ padding: "20px", textAlign: "center", color: "red" }}>{error}</div>;
//   }

//   return (
//     <div className="firerisk-awareness" style={{ margin: "20px" }}>
//       <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>FireRisk Advisory</h3>
//       {/* Display general error if it occurred but list might still be visible (e.g. from a previous successful fetch) */}
//       {error && advisories.length > 0 && <p style={{ padding: "10px", textAlign: "center", color: "red", background: "#ffebee", border: "1px solid red", borderRadius: "4px" }}>{error}</p>}

//       {advisories.length > 0 ? (
//         <table className="advisory-table" style={{ width: "100%", borderCollapse: "collapse", boxShadow: "0 2px 5px rgba(0,0,0,0.1)" }}>
//           <thead style={{ backgroundColor: "rgb(225, 232, 242)" }}>
//             <tr>
//               <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left", width: "33%" }}>Type / Heading</th>
//               <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left", width: "33%" }}>Advisory in English</th>
//               <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left", width: "34%" }}>Avizu iha lian Tetum</th>
//             </tr>
//           </thead>
//           <tbody>
//             {advisories.map((advisory, index) => (
//               <tr key={advisory.id || index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white" }}>
//                 <td style={{ border: "1px solid #ccc", padding: "12px", verticalAlign: "top" }}>
//                   {advisory.englishheading && <div><strong>English:</strong> {advisory.englishheading}</div>}
//                   {advisory.tetumheading && advisory.englishheading && <hr style={{margin: '8px 0'}}/>}
//                   {advisory.tetumheading && <div><strong>Tetum:</strong> {advisory.tetumheading}</div>}
//                   {(!advisory.englishheading && !advisory.tetumheading) && <span>No heading available</span>}
//                 </td>
//                 <td style={{ border: "1px solid #ccc", padding: "12px", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: advisory.englishdescription || "<p>No description available.</p>" }} />
//                 <td style={{ border: "1px solid #ccc", padding: "12px", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: advisory.tetumdescription || "<p>Laiha deskrisaun.</p>" }} />
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       ) : (
//         <p style={{ textAlign: "center", padding: "20px" }}>
//           {isLoading ? "" : "No firerisk advisories are currently available."}
//         </p>
//       )}
//       {/* Loading indicator for ongoing fetch operation after initial screen */}
//       {isLoading && advisories.length > 0 && <div style={{textAlign: 'center', padding: '10px', color: 'blue', fontWeight: 'bold'}}>Refreshing data...</div>}
//     </div>
//   );
// };

// export default Fireadvisory;


import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
// Assuming 'Switch' is a common component that you have
import Switch from '../../../common/Switch';


// Styled components for a clean and maintainable UI
const LanguageToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 16px;
  padding-right: 24px;
`;

const LanguageLabel = styled.span`
  font-size: 12px;
  color: #4B5563;
  font-weight: 500;
`;

const Fireadvisory = () => {
  const [advisories, setAdvisories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  // New state to manage the language toggle
  const [showTetum, setShowTetum] = useState(false);
  const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;


  // Function to fetch advisories from the backend
  // Wrapped in useCallback to prevent unnecessary re-creations
  const fetchAdvisories = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(`${backendUrl}/firerisk/firerisk-advisories/`);
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}. Response: ${errorText.substring(0, 200)}`);
      }
      const data = await response.json();
      setAdvisories(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("Failed to fetch advisories:", e);
      setError("Failed to load advisories. Please try again later.");
      setAdvisories([]);
    } finally {
      setIsLoading(false);
    }
  }, [backendUrl]);

  // useEffect hook to call fetchAdvisories only once on component mount
  useEffect(() => {
    fetchAdvisories();
  }, [fetchAdvisories]);

  // Initial loading state before any advisories are fetched
  if (isLoading && advisories.length === 0 && !error) {
    return <div style={{ padding: '24px', textAlign: 'center', color: '#374151', fontSize: '16px' }}>Loading advisories...</div>;
  }

  // Display error message if the initial fetch failed and no data is available
  if (error && advisories.length === 0) {
    return <div style={{ padding: '24px', textAlign: 'center', color: '#EF4444', fontSize: '16px' }}>{error}</div>;
  }

  return (
    <div style={{ width: '100%', margin: '0 auto', padding: '20px 10px', backgroundColor: '#ffffff', borderRadius: '8px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: '-5px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: '600', color: 'rgba(27, 108, 194, 0.83)', marginBottom: '8px' }}>
          Fire Risk Advisory
        </h1>
        <p style={{ color: '#4B5563', fontSize: '16px' }}>
          {showTetum ? 'informasaun no konsellu kona-ba perigu ahi' : 'Information and safety advice regarding fire risk'}
        </p>
      </div>

      {/* Language toggle component */}
      <LanguageToggleWrapper>
        <LanguageLabel>English</LanguageLabel>
        <Switch onChange={() => setShowTetum(!showTetum)} />
        <LanguageLabel>Tetum</LanguageLabel>
      </LanguageToggleWrapper>

      {error && advisories.length > 0 && (
        <p
          style={{
            padding: '12px',
            textAlign: 'center',
            color: '#EF4444',
            background: '#FEF2F2',
            border: '1px solid #EF4444',
            borderRadius: '4px',
            marginBottom: '24px',
          }}
        >
          {error}
        </p>
      )}

      {advisories.length > 0 ? (
        <table style={{ width: '100%', borderCollapse: 'collapse', borderRadius: '8px', overflow: 'hidden' }}>
          <thead style={{ backgroundColor: '#dededeff', borderBottom: '1px solid #E5E7EB' }}>
            <tr>
              {/* Dynamic header text */}
              <th
                style={{
                  padding: '12px 24px',
                  textAlign: 'left',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#111827',
                  width: '33.33%',
                }}
              >
                {showTetum ? 'Tipu' : 'Type'}
              </th>
              {/* Dynamic header text */}
              <th
                style={{
                  padding: '12px 24px',
                  textAlign: 'left',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#111827',
                  width: '66.67%',
                }}
              >
                {showTetum ? 'Avizu' : 'Advisory'}
              </th>
            </tr>
          </thead>
          <tbody style={{ borderTop: 'none', backgroundColor: '#fdfdfdff' }}>
            {advisories.map((advisory) => (
              <tr
                key={advisory.id}
                style={{
                  transition: 'background 0.2s',
                  borderBottom: '1px solid #E5E7EB',
                }}
                onMouseOver={(e) => (e.currentTarget.style.background = '#F9FAFB')}
                onMouseOut={(e) => (e.currentTarget.style.background = '#FFFFFF')}
              >
                {/* Dynamic heading text */}
                <td style={{ padding: '16px 24px', verticalAlign: 'top' }}>
                  <p style={{ fontSize: '14px', color: '#111827' }}>
                    {showTetum ? (advisory.tetumheading || 'Laiha tipu') : (advisory.englishheading || 'No heading available')}
                  </p>
                </td>
                {/* Dynamic description text */}
                <td style={{ padding: '16px 24px', verticalAlign: 'top' }}>
                  <div
                    style={{ fontSize: '14px', color: '#374151' }}
                    dangerouslySetInnerHTML={{
                      __html: showTetum
                        ? (advisory.tetumdescription || '<p>Laiha deskrisaun.</p>')
                        : (advisory.englishdescription || '<p>No description available.</p>')
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p style={{ textAlign: 'center', padding: '48px 0', color: '#6B7280', fontSize: '16px' }}>
          {isLoading ? '' : (showTetum ? 'Laiha avizu kona-ba perigu ahi.' : 'No fire risk advisories are currently available.')}
        </p>
      )}
      {isLoading && advisories.length > 0 && (
        <div style={{ textAlign: 'center', padding: '12px', color: '#2563EB', fontWeight: '500', fontSize: '16px' }}>
          Refreshing data...
        </div>
      )}
    </div>
  );
};

export default Fireadvisory;